<div class="upsell-video w-[750px] max-w-[100%] mx-auto mb-8 px-4 desktop:px-0">
  <video-player
    [videoID]="videoID"
    [videoPlayType]="videoPlayType"
    [accountID]="accountID"
  ></video-player>
</div>